// Routes that should not trigger automatic redirect to login on auth errors
export const PASSWORD_FLOW_ROUTES = ["/password-reset", "/password-forgot", "/onboarding"];
